import { useEffect, useState } from 'react';
import { callMsGraphGroup } from '../../graphGroup';
import { useMsal } from '@azure/msal-react';
import { profileRequest } from '../../authConfig';
import { ProfileType } from '../../model/datatype';
import { getInfoUsers } from '../../services/ApiGetUserInfo';
import { useNavigate } from 'react-router-dom';
import { isMobile } from 'react-device-detect';

// is-mobile

export const Topbar = (props: any) => {
  const { instance, accounts } = useMsal();
  const [isLoading, setIsLoading] = useState(false);
  const [graphData, setGraphData] = useState(false);
  const [data, setData] = useState<ProfileType | null>(null);
  const [profilePhoto, setProfilePhoto] = useState<string>('/images/user.png');
  const navigate = useNavigate();

  useEffect(() => {
    console.log(isMobile);
    if (isMobile) {
      navigate('/desktop-olny');
    }
    if (data === null) {
      getInfoUsers().then((response) => {
        const getData: any = response;
        setData(getData);
      });
    }

    const stored = sessionStorage.getItem('GraphAccessToken');
    if (stored) {
      const token = JSON.parse(stored).value;
      fetch('https://graph.microsoft.com/v1.0/me/photo/$value', {
        headers: { Authorization: `Bearer ${token}` },
      })
        .then((res) => {
          if (res.ok) return res.blob();
          throw new Error('no photo');
        })
        .then((blob) => setProfilePhoto(URL.createObjectURL(blob)))
        .catch(() => setProfilePhoto('/images/user.png'));
    }
  }, [data]);

  return (
    <div className="admin-top-bar">
      <div className="row">
        <div className="col-12 col-sm-7 col-md-7"></div>
        <div className="col-12 col-sm-5 col-md-5">
          <div className="user-profile d-flex align-items-center float-end gap-2">
            <div className="text-end">
              <div className="user-name">{data?.employeeNameEn}</div>
              <div className="user-role">Admin</div>
            </div>
            <div className="profile-avatar">
              <img src={profilePhoto} alt="profile" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
